export default __webpack_public_path__ + "static/media/uwblueprint.a60653be.png";